export default {
  PAYMENT_TYPE: {
    DEBITO: 'debito-em-conta',
    PENDENTE: 'pendente',
  },

  ROLES: {
    LIMIT_SIMULATION_BANK_VISIBILITY: ['salesman', 'sales_manager'],
    LIMIT_FI_PERFORMANCE_VISIBILITY: ['salesman', 'sales_manager'],
    SHOW_FULL_LEADS_FORM_TO_SELLERS: ['salesman', 'sales_manager'],
    ALLOW_COMMERCIAL_CONTROL_CUSTOMIZATION_BY_SELLERS: ['salesman', 'sales_manager'],
  },
};
